// The rollout segment the backend reports for a device (SRS SVC-RO-003: the
// countries a rollout names plus the serials selected in them). Shared by the
// fleet list (WP-FL-04) and the device detail view (WP-FL-04a, FMP-DV-001).
export function formatSegment(segment) {
  if (!segment || typeof segment !== "object") return { text: "Not in rollout", className: "text-slate-400" };
  const countries = (segment.countries || []).join(", ");
  const version = segment.firmware_version ? ` · ${segment.firmware_version}` : "";
  if (segment.in_segment) return { text: `${countries}${version}`, className: "text-slate-600 font-medium" };
  return { text: `Selected (${countries}) · not eligible`, className: "text-amber-600" };
}
